import DefaultView from './brand-cloud.default'
import merge from 'lodash/merge'
import useBcBookmarkStore from '@/frontapp/store/bcBookmark'
import useBcHomeStore from '@/frontapp/store/bcHome'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { mapStores } from 'pinia'
import { FolderApi, DocumentApi } from '../test-api/index.ts'
import handleApiError from '../utils/handleApiError'


let recentlyViewedLoaded = false

export default merge({
  data() {
    return {
    }
  },
  computed: {
    ...mapStores(useBcBookmarkStore, useBcHomeStore, useBcSelectedStore),
  },
  mounted() {
    if (this.$el.id !== 'snippet--app') {
      return
    }

    this.bcFolderStore.show = 'bc'
    this.bcFolderStore.loadFolder(null)
    const rootFolder = merge({}, this.$presenter.rootFolder)
    rootFolder.id = 0 // fix create new folder / document on root because this.bcFolderStore.listChildren[this.bcFolderStore.current.id]
    this.bcFolderStore.current = rootFolder
    this.bcSelectedStore.reset(null, 'url', null, false)
    this.bcFolderStore.leftMenuCurrent = {}
    
    if (recentlyViewedLoaded === false) {
      this.bcHomeStore.recentlyViewedDocuments = [...this.recentlyViewed]
      this.bcBookmarkStore.bookmarks = [...this.bookmarks]
      recentlyViewedLoaded = true
    }

    if (this.$route.hash) {
      const hashUrlArr = this.$route.hash.split('/')
      if (hashUrlArr[1] === 'region') {
        const folderApi = new FolderApi({}, '/api/v2')
        handleApiError(() => folderApi.folderOldGet(parseInt(hashUrlArr[2]), parseInt(hashUrlArr[3])).then((folderResponse) => {
          const url = new URL(folderResponse.data.url)
          this.$router.replace(url.pathname)
        }))

      } else if (hashUrlArr[1] === 'document') {
        const documentApi = new DocumentApi({}, '/api/v2')
        handleApiError(() => documentApi.documentOldGet(parseInt(hashUrlArr[2]), parseInt(hashUrlArr[3])).then((documentResponse) => {
          const url = new URL(documentResponse.data.url)
          this.$router.replace(url.pathname)
        }))
      
      } else if (hashUrlArr[1] === 'search') {
        this.$router.replace('/search/' + hashUrlArr[2])
      }
    }
  },
}, DefaultView)
